// Custom script to handle cart page functionality
document.addEventListener('DOMContentLoaded', function() {
  // Only run this on the cart page
  if (window.location.pathname === '/cart') {
    // Wait for Alpine.js to initialize
    const waitForAlpine = setInterval(function() {
      if (window.Alpine) {
        clearInterval(waitForAlpine);
        
        // Override the openCart function to work on cart page
        const originalOpenCart = window.Alpine.store('xMiniCart').openCart;
        window.Alpine.store('xMiniCart').openCart = function() {
          // Remove the pathname check
          requestAnimationFrame(() => {
            if (window.Alpine.store('xQuickView') && window.Alpine.store('xQuickView').show) {
              window.Alpine.store('xQuickView').show = false;
            }
          });

          requestAnimationFrame(() => {
            if (document.getElementById('sticky-header')) {
              document.getElementById('sticky-header').classList.remove('on-scroll-up-animation');
            }

            if (window.innerWidth < 768 || this.type == "drawer") {
              setTimeout(() => {
                window.Alpine.store('xPopup').open = true;
              }, 500);
            }

            requestAnimationFrame(() => {
              if (document.getElementById('sticky-header')) {
                document.getElementById('sticky-header').classList.remove('header-up');
              }
              this.open = true;
            });
            
            if (window.Alpine.store('xHeaderMenu') && window.Alpine.store('xHeaderMenu').stickyType == 'on-scroll-up') {
              setTimeout(() => {
                requestAnimationFrame(() => {
                  if (document.getElementById('sticky-header')) {
                    document.getElementById('sticky-header').classList.add('on-scroll-up-animation');
                  }
                });
              }, 200);
            }
          });
        };
        
        // Trigger cart opening
        setTimeout(function() {
          window.Alpine.store('xMiniCart').openCart();
        }, 500);
      }
    }, 100);
  }
}); 